module.exports = __webpack_public_path__ + "static/media/noto_sad-but-relieved-face.19dcde31.svg";